export default {
  title: 'Impressum',
  subtitle: "Personalizza i dettagli mostrati nell'Impressum del tuo negozio senza modificare il profilo aziendale.",
  defaultsNotice:
    "Ogni campo è opzionale. Lascialo vuoto per continuare a usare il valore del profilo aziendale — il valore predefinito corrente è mostrato in grigio come anteprima. Compilare un campo sovrascrive solo l'Impressum; il profilo aziendale rimane invariato.",
  fields: {
    legal_name: {
      label: 'Ragione sociale / nome legale',
      placeholder: 'es. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Nome del titolare',
      placeholder: 'es. Alex',
    },
    owner_last_name: {
      label: 'Cognome del titolare',
      placeholder: 'es. Müller',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'es. info@example.com',
      invalid: 'Inserisci un indirizzo email valido',
    },
    owner_phone_number: {
      label: 'Telefono',
      placeholder: 'es. +49 30 1234567',
    },
    tax_id: {
      label: 'Codice fiscale',
      placeholder: 'es. DE123456789',
    },
    address: {
      label: 'Indirizzo',
      placeholder: 'Via, CAP, città',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    saved: 'Impressum salvato',
    failed: "Salvataggio dell'Impressum non riuscito",
  },
};
